import React, { useContext } from 'react';
import styles from '../styles';
import { PlayerInfoWrapper, PlayerInfoBox, LabelHolder, DividerWrapper } from '../styledComponents';
import CopySelector from 'shared/utils/copySelector';
import ThemeContext from 'shared/context/ThemeContext';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import ImageBW from '../../../../components/ImageBoundsWrapper';

const PlayerInfo = props => {
  const { Account } = useContext(ThemeContext);
  const { playerId, casinoId, email, isGuestUser } = props;

  return (
    <>
      <PlayerInfoWrapper>
        <PlayerInfoBox>
          <LabelHolder
            theme={Account.Label}
            className="account-title"
            data-label={CopySelector.getCopy(CopySelector.COPY_TYPES.MY_USER_ID)}
          ></LabelHolder>
          <span className="account-value">{playerId || getText(TEXT_KEY.NONE)}</span>
        </PlayerInfoBox>
        <PlayerInfoBox>
          <LabelHolder
            theme={Account.Label}
            className="account-title"
            data-label={CopySelector.getCopy(CopySelector.COPY_TYPES.MEMBER_ID)}
          ></LabelHolder>
          <span className={`account-value`} data-label={casinoId || getText(TEXT_KEY.NONE)}></span>
        </PlayerInfoBox>
      </PlayerInfoWrapper>
      <DividerWrapper>
        <ImageBW
          style={styles.divider}
          source={require(asset`./images/Settings/Settings_Divider@3x.png`)}
          ibw={require(asset`./images/Settings/Settings_Divider.ibw`)}
          widthScale={0.5}
        />
      </DividerWrapper>
      {(ENVIRONMENT_VARIABLES.ACCOUNT_EMAIL.toString() === 'false' || isGuestUser) && (
        <PlayerInfoBox>
          <LabelHolder theme={Account.Label} className="account-title">
            {getText(TEXT_KEY.EMAIL)}
          </LabelHolder>
          <span className="account-value">{email || getText(TEXT_KEY.NONE)}</span>
        </PlayerInfoBox>
      )}
    </>
  );
};
export default PlayerInfo;

